<template>
  <div class="con_box" v-if="is_show">
    <public-header :routArg="routArg"></public-header>
    <!-- 上 -->
    <div class="content_head">
      <h2>{{ data.name }}</h2>
      <!-- 封面 -->
      <div class="cover">
        <img :src="data.cover" alt="" />
      </div>
      <!-- 播放器 -->
      <div class="play_tab">
        <span @click="give_click">送给好友</span>
        <span v-if="status==0" @click="by_end">我已学完</span>
        <span @click="listShow=true">学习列表</span>
      </div>
      <div class="player">
        <public-audio2 ref="play" :mini="false" :volume="0.8" :src="data.audio" @ratechange="rateChange" @playing="playIng" @playstop="playStop" @playstart="playStart" @playready="playReady" />
      </div>
    </div>
    <!-- 下 -->
    <div class="content_main">
      <h2 class="title">课程文稿</h2>
      <div class="container" v-html="data.content">
        <!-- 填充内容 -->
      </div>
    </div>
    <div class="banq">
      * 本课程由新精英生涯（北京）教育科技有限公司版权所有，违者必究
    </div>
    <div class="men_foot">
      <!-- <a class="men_fl" @click="pop_show = true">
        <img src="../../../assets/share_ic.png" />推荐
      </a> -->
      <div class="men_fr">
        <a v-if="data.project_type == 1" @click="doUnlockProject">立即报名</a>
        <!-- <a v-else :href="'project_details.html?cid='+ cid + '&cpid=' + cpid + '&type=' + type">进入项目</a> -->
        <router-link v-else :to="`/project_details?cid=${cid}&cpid=${cpid}&type=${type}`">进入项目</router-link>
      </div>
    </div>
    <!--  -->
    <div v-show="fixed_show" :class="[footer_show ? 'show' : 'hide', 'play_foot clearfix']">
      <img src="../../../assets/play_close.png" v-show="!js_play" @click="play_close_click" />
      <div :class="[!js_play ? '' : 'pause_h2' , 'play_f']">
        <h2>{{data.pblname}}-{{data.name}}</h2>
        <h3>{{timeStr}}</h3>
      </div>
      <span @click="js_play_click" :class="[js_play ? 'pause_audio' : '', 'play-btn']"></span>
    </div>
    <!-- 手机验证 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <div class="pop_img" v-show="pop_show" @click="pop_show = false"></div>
    <!-- 解锁更多项目 -->
    <van-popup v-model="unlock_project" position="bottom">
      <div class="share_order">
        <div class="share-content">
          <img src="@a/sha2.png" class="close" alt="" @click="unlock_project=false" />
          <div class="clearfix"></div>
          <h2>请选择合适的课程</h2>
          <van-radio-group :class="['order_group',!item.sign?'radio_group_over':'','clearfix']" v-for="(item,index) in courseData.list" :key="index" v-model="radio" :disabled="!item.sign?true:false">
            <van-radio class="clearfix" :name="item.id">
              {{item.begintime}} 开课
            </van-radio>
          </van-radio-group>
          <div class="clearfix"></div>
        </div>
        <!-- 优惠 -->
        <div v-if="is_red" class="discounts">
          <h2>课程优惠</h2>
          <van-radio-group v-for="(item,index) in order_group" :key="index" class="discounts-radio" v-model="use_id">
            <van-cell-group>
              <van-cell clickable>
                <van-radio slot="right-icon" :name="item.id" />
                <template slot="title">
                  {{item.name}}<span>- ￥{{item.price}}</span>
                </template>
              </van-cell>
              <p class="discounts-small">不可与其它优惠同时享受</p>
            </van-cell-group>
          </van-radio-group>
        </div>
        <!-- 立即报名 -->
        <div class="unlock-btn">
          <a class="unlock-btn-left">
            <div>
              <span v-if="use_id" class="money">
                <s>￥{{courseprice}}</s>
              </span>
              <span v-else class="money">
                ￥{{courseprice}}
              </span>
              <span>仅剩席位{{surplus}}</span>
            </div>
          </a>
          <a @click="signHandle" v-if="surplus>0" class="unlock-btn-right">
            立即报名 ￥{{order_price}}
          </a>
          <a class="unlock-btn-right on" v-else>本期已满</a>
        </div>
        <!-- 未关注弹窗 -->
        <van-popup :close-on-click-overlay="false" v-model="assistant_show" class="pop_assistant">
          <div class="pop_assistant_box">
            <h3 style="font-weight: bold">{{data.userdetail.name}}你好！您已成功报名{{data.courseName}}，为了不和组织失联，请关注下方二维码。</h3>
            <h4>识别或扫描二维码</h4>
            <img src="@a/carrer.png" />
            <h4>已关注的看官自动忽略</h4>
          </div>
        </van-popup>
      </div>
    </van-popup>
    <van-popup v-model="listShow" position="bottom">
      <div class="list_audio">
        <h2>学习列表<span @click="listShow=false">关闭</span></h2>
        <ul>
          <li v-for="(item,index) in project_list" :key="index" class="clearfix">
            <!-- 类型 1测评 2课程音频 3任务 4讨论小组 -->
            <a :href="item.skip" class="list_href" v-if="item.type==1">{{index+1}}. 测评：{{item.name}}</a>
            <a class="list_href" v-else-if="item.type==2" @click="list_h(item.table_id)">{{index+1}}. 课程：{{item.name}}</a>
            <router-link v-else-if="item.type==3" :to="item.skip + '?cid=' + cid + '&pid=' + pid + '&id=' + item.table_id" class="list_href">{{index+1}}. 任务：{{item.name}}</router-link>
            <router-link class="list_href" v-else-if="item.type==4" :to="{
                path: '/discuss',
                query: {
                  'table_id': item.table_id
                }
              }">{{index+1}}. 讨论：{{item.name}}</router-link>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  statistics
} from "@/api/public"
import {
  setStorage,
  getStorage
} from "@/utils/tools"
import {
  coursedetail,
  statistic_next,
  getsubject,
  subjectstatus
} from "@/api/course"
import {
  getProject
} from "@/api/course2";
import {
  shareCon
} from "@/utils/wxconfig"
import {
  get_gift
} from "@/api/pay"
export default {
  data() {
      return {
        lock: false,
        prevTime: 0,
        is_show: false,
        js_play: false,
        pop_show: false,
        timeStr: "00:00 / 00:00",
        footer_show: false,
        fixed_show: true,
        isSetMemory: false,
        data: {},
        sharecode: "",
        // 神策统计音频
        project_name: '',
        name: '',
        isPay: '',
        listen_audio_time: 0,
        listen_audio_speed: 1,
        status: null,
        routArg: {},
        // 解锁更多项目
        unlock_project: false,
        courseprice: null,
        originalprice: null,
        order_group: [],
        use_id: null,
        radio: '',
        order_price: '',
        courseData: {},
        sharetype: "",
        is_red: false,
        surplus: null,
        details_cid: null,
        assistant_show: false,
        listShow: false,
        project_list: []
      }
    },
    props: {
      pulldata: Object
    },
    computed: {
      id() {
        return this.$route.query.id
      },
      cid() {
        return this.$route.query.cid
      },
      cpid() {
        return this.$route.query.cpid || String(this.data.cpid)
      },
      pid() {
        return this.$route.query.cpid || String(this.data.cpid)
      },
      type() {
        return this.$route.query.type || ''
      },
      pdk() {
        return this.$route.query.pdk;
      },
      aspx() {
        return this.$route.query.aspx;
      },
      source() {
        return this.$route.query.source;
      }
    },
    methods: {
      // 音频跳转 重新渲染
      list_h(table_id) {
        this.$router.push({
          path: '/course_content',
          query: {
            'id': table_id,
            'cid': this.cid,
            'cpid': this.pid,
            'pdk': this.routArg.pdk,
            'aspx': this.routArg.aspx,
            'source': this.routArg.source
          }
        });
        window.location.reload()
      },
      // 监听音频变速
      rateChange() {
        this.listen_audio_speed = this.$refs.play.speedVal;
        this.audioPolicyHandle(true, getStorage('godPolicy', 'godPolicy'));
      },
      // 手机验证
      statistic_() {
        statistic_next({
            cid: this.cid
          })
          .then(() => {});
      },
      statistical(data) {
        statistics({
          type: data
        }).then(() => {});
      },
      // 解锁更多项目
      doUnlockProject() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });

        console.log(this.courseData == {});
        coursedetail({
          bid: this.bid
        }).then((data) => {
          this.courseData = data;



          this.sharetype = this.courseData.sharetype;
          // 清除加载
          this.$toast.clear();
          this.is_red = !this.courseData.redType && this.courseData.redPrice != '';
          // 课程期数
          for (let arg of this.courseData.list) {
            if (arg.selected) {
              this.courseprice = arg.courseprice;
              this.originalprice = arg.originalprice;
              this.surplus = arg.surplus;
              this.details_cid = String(arg.id);
              this.radio = arg.id;
              this.order_price = arg.courseprice;
            }
          };
          if (this.is_red && this.courseData.otheractivity) {
            // 后台红包只取最大，所以默认只有一个
            this.order_group[0] = {
              name: "红包折扣",
              price: this.courseData.redPrice.use_money,
              id: this.courseData.redPrice.use_id
            };
          }

          if (this.is_red) {
            this.order_price = (this.originalprice * 100 - this.courseData.redPrice.use_money * 100) / 100;
          }

          shareCon("course", this);
          // 神策统计
          sensors.track('courseContent', {
              classification: this.courseData.bigcoursename,
              classification_id: this.$route.query.bid,
              channel_name: this.source || '',
              course_id: this.cid,
              course_name: this.courseData.coursename,
              share_user_id: this.pdk || '',
              course_discount_price: this.courseData.courseprice,
              course_original_price: this.courseData.originalprice,
              course_starttime: this.courseData.begintime,
              // 新增
              course_user_type: this.courseData.ishavedbuy ? "已付费" : "未付费"
            })
            // 显示解锁项目弹窗
          this.unlock_project = true;
        })
      },
      // 立即报名
      signHandle() {
        this.statistical("lefticon");
        // 神策
        // sensors.track('clickToEnroll', {
        //   campaignName: this.source || '',
        //   courseID: this.cid,
        //   courseName: '个人战略商业价值重塑'
        // });
        // ---------------------解锁更多项目-----------------------------
        this.statistical("coursebtn");
        // 神策统计--点击立即报名按钮
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.courseData.bigcoursename,
          classification: this.courseData.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.courseData.coursename,
          course_discount_price: this.courseData.courseprice,
          course_original_price: this.courseData.originalprice,
          course_starttime: this.courseData.begintime
        });
        // 神策统计--点击立即报名按钮
        let godPolicy = getStorage('godPolicy', 'godPolicy');
        this.godPolicyHandle(true, godPolicy);

        if (this.courseData.refunding) {
          this.$toast("有退款订单，不能购买！");
        } else {
          if ((this.courseData.shareinfo || this.is_red) && !this.unlock_project) {
            this.unlock_project = true;
          } else {
            if (this.courseData.mobilestatus) {
              // 是否需要验证验证码
              this.$refs.handle.need_verify = this.courseData.need_verify || false;
              // 判断用户手机号是否已验证
              this.$refs.handle.phone = this.courseData.userdetail.mobile ? this.courseData.userdetail.mobile : null;
              this.$refs.handle.show = true;
            } else {
              this.$refs.handle.pay()
            }
          }
        }
        // if (this.data.mobilestatus) {
        //   // 是否需要验证验证码
        //   this.$refs.handle.need_verify = this.data.need_verify || false;
        //   // 判断用户手机号是否已验证
        //   this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
        //   this.$refs.handle.show = true;

        // } else {
        //   this.$refs.handle.pay()
        // }
      },
      // 立即报名神策方法
      godPolicyHandle(bool, godPolicy) {
        // 判断缓存是否有数据，如果没有请求数据
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.name,
          classification: bool ? godPolicy.classification : godPolicy.bigcoursename,
          classification_id: 1, //bid
          course_id: this.$route.query.cid,
          course_name: bool ? godPolicy.course_name : godPolicy.coursename,
          course_discount_price: bool ? godPolicy.course_discount_price : godPolicy.courseprice,
          course_original_price: bool ? godPolicy.course_original_price : godPolicy.originalprice,
          course_starttime: bool ? godPolicy.course_starttime : godPolicy.begintime
        });
      },
      play_close_click() {
        this.fixed_show = false;
      },
      js_play_click() {
        if (this.js_play) {
          this.$refs.play.playStop();
        } else {
          this.$refs.play.playStart();
        }
      },
      playStart(ev) {
        this.js_play = true;
      },
      playStop(ev) {
        this.js_play = false;
      },
      playReady(ev, allTime) {
        this.timeStr = `00:00 / ${allTime}`;
        if (this.isSetMemory) {
          return
        }
        this.setMemory();
      },
      setMemory() {
        let storPath = this.$route.path;
        let isStora = window.localStorage[storPath];
        // 用于神策统计
        if (isStora) {
          let memoryDate = getStorage(storPath, 'curTime');
          this.$refs.play.audio.currentTime = Number(memoryDate);
        }
        this.isSetMemory = true;
      },
      playIng(ev, curTime, allTime) {
        this.timeStr = `${curTime} / ${allTime}`;
        // 计算时间
        let getDate = new Date().getTime();
        // 本地存储
        if (getDate - this.prevTime > 5000) {
          this.prevTime = getDate;
          let storPath = this.$route.path;
          // 当前时间
          let curDate = ev.srcElement.currentTime;
          setStorage(storPath, 'curTime', curDate);
          // 全部时间
          let allDate = ev.srcElement.duration;
          setStorage(storPath, 'allDate', allDate);
          // 字符串格式时间
          setStorage(storPath, 'strTime', this.timeStr);
          // 标题
          let title = this.data.name;
          setStorage(storPath, 'title', title);
          // 参数
          let query = this.$route.query;
          let strQuery = JSON.stringify(query);
          setStorage(storPath, 'query', strQuery);
        }
        // 听课完成
        let curDate = ev.srcElement.currentTime;
        let allDate = ev.srcElement.duration;
        let isHearLoad = (allDate - curDate) <= 15;
        if ((allDate - curDate) == 0) {
          // 神策音频
          this.audioPolicyHandle(true, getStorage('godPolicy', 'godPolicy'), true);
        }
        if (isHearLoad && !this.lock) {
          // 锁定，禁止下次进入
          this.lock = true;
          // 统计听课完成
          let q = this.$route.query;
          subjectstatus({
              cid: q.cid,
              cpsid: q.id
            })
            .then(() => {})
        }
      },
      projectList() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let querys = this.$route.query;
        getProject({
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid,
            pdk: this.$route.query.pdk ? this.$route.query.pdk : '',
            aspx: this.$route.query.aspx ? this.$route.query.aspx : "",
          })
          .then((data) => {
            this.$toast.clear();
            this.is_show = true;
            this.project_list = data.list;
          })
      },
      pullData(data) {
        this.projectList();
        // 获取数据
        this.data = data;
        this.name = data.name;
        this.bid = data.bid;
        this.project_name = data.project_name;
        this.isPay = data.ishavedbuy ? '已付费' : '未付费';
        this.status = data.status;
        this.cacheUserConfig = {
          pdk: data.pdk,
          aspx: data.aspx
        };
        // 判断是否关注
        // if (!data.subscribe && data.project_type == 0) {
        //   this.assistant_show = true;
        // }
        shareCon("course", this);
        let querys = this.$route.query;
        if (querys.source) {
          this.routArg['source'] = querys.source;
        }
        if (querys.pdk) {
          this.routArg['pdk'] = querys.pdk;
        }
        if (querys.aspx) {
          this.routArg['aspx'] = querys.aspx;
        }
        // 音频添加神策
        let godPolicy = getStorage('godPolicy', 'godPolicy');
        let bool = true;
        if (!godPolicy || godPolicy.length == 0) {
          bool = false;
          coursedetail({
              bid: this.bid
            })
            .then((data) => {
              // 用户试学解锁更多项目用
              this.courseData = data;
              //
              godPolicy = data;
              // 把神策数据存到本地缓存
              let go = {
                course_id: this.cid,
                classification: data.bigcoursename,
                course_name: data.coursename,
                course_discount_price: data.courseprice,
                course_original_price: data.originalprice,
                course_starttime: data.begintime
              };
              setStorage('godPolicy', 'godPolicy', go);
              this.audioPolicyHandle(false, godPolicy);
            })
        } else {
          this.audioPolicyHandle(true, getStorage('godPolicy', 'godPolicy'));
        }
      },
      // 项目课程神策方法
      audioPolicyHandle(bool, godPolicy, is_finish_audio) {
        // 判断缓存是否有数据，如果没有请求数据
        sensors.track('projectAudio', {
          course_id: this.$route.query.cid,
          course_name: bool ? godPolicy.course_name : godPolicy.coursename,
          project_id: this.$route.query.cpid,
          project_name: this.project_name,
          audio_id: this.id,
          audio_name: this.name,
          is_finish_audio: is_finish_audio ? is_finish_audio : false,
          listen_audio_time: this.listen_audio_time,
          listen_audio_speed: this.listen_audio_speed,
          course_user_type: this.isPay
        });
      },
      onScroll() {
        window.onscroll = (ev) => {
          let t = document.documentElement.scrollTop || document.body.scrollTop;
          let w = document.documentElement.clientHeight;
          if (t > w) {
            this.footer_show = true;
          } else {
            this.footer_show = false;
          }
        }
      },
      give_click() {
        get_gift({
            subject_id: this.id
          })
          .then((data) => {
            this.sharecode = data.sharecode;
            this.$router.push({
              path: '/give_share',
              query: {
                bid: this.data.bid,
                subject_id: this.id,
                sharecode: this.sharecode,
                cid: this.cid,
                cpid: this.cpid
              }
            });
          })
      },
      // 我已学完
      by_end() {
        let q = this.$route.query;
        subjectstatus({
            cid: q.cid,
            cpsid: q.id
          })
          .then(() => {
            this.status = 1;
          })
      }
    },
    created() {
      this.pullData(this.pulldata);
    },
    mounted() {
      this.onScroll();
    },
    watch: {
      radio(curVal, oldVal) {
        // 修改课程期数
        for (let arg of this.courseData.list) {
          if (arg.id == curVal) {
            this.courseprice = arg.courseprice;
            this.originalprice = arg.originalprice;
            this.surplus = arg.surplus;
            if (this.use_id) {
              this.order_price = (this.courseprice * 100 - this.courseData.redPrice.use_money * 100) / 100;
            } else {
              this.order_price = arg.courseprice;
            }
          }
        };
        this.cid = String(curVal);
      },
      use_id(curVal, oldVal) {
        if (curVal) {
          this.order_price = (this.courseprice * 100 - this.courseData.redPrice.use_money * 100) / 100;
        } else {
          this.order_price = arg.courseprice;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.con_box {
  * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  input {
    -webkit-user-select: auto;
    user-select: auto;
  }
  padding-bottom: 100px;
}

.content_head {
  background: #fff;
  text-align: center;
  padding: changeRem(0.8)+px changeRem(0.6)+px;
  width: 100%;
  h2 {
    line-height: changeRem(0.84)+px;
    font-size: changeRem(0.68)+px;
    color: #333;
    font-weight: normal;
  }
}

.cover {
  padding-top: changeRem(0.9)+px;
  img {
    width: changeRem(10)+px;
    height: auto;
    margin: 0 auto;
    vertical-align: middle;
    border-radius: changeRem(0.16)+px;
  }
}

.player {
  width: changeRem(10)+px;
  height: 100%;
  margin: 0 auto;
  margin-top: changeRem(1)+px;
}

.text-left {
  display: flex;
}

.shareAnd {
  font-size: 28px;
  color: #EB5032;
  font-weight: bold;
  text-align: left;
}

.byEnd {
  margin-left: auto;
  font-size: 28px;
  color: #F5831E;
  font-weight: bold;
  text-align: right;
}

.content_main {
  margin: 0 auto;
  margin-top: changeRem(0.4)+px;
  background: #fff;
  text-align: left;
  padding: changeRem(0.6)+px;
  width: 100%;
  .title {
    line-height: changeRem(0.84)+px;
    font-size: changeRem(0.68)+px;
    color: #333;
    font-weight: bold;
  }
}

.container {
  text-align: justify;
  width: 100%;
  margin-top: changeRem(0.6)+px;
  overflow: hidden;
}

.men_foot {
  width: 100%;
  height: changeRem(1.96)+px;
  line-height: changeRem(1.96)+px;
  position: fixed;
  bottom: 0;
  left: 0;
  max-width: 750px;
  text-align: center;
  background: #fff;
}

.men_fl {
  width: changeRem(3.6)+px;
  display: block;
  float: left;
  color: #F58526;
  font-size: changeRem(0.52)+px;
  img {
    width: changeRem(0.56)+px;
    height: changeRem(0.56)+px;
    margin-right: changeRem(0.24)+px;
    vertical-align: text-top;
  }
}

.men_fr {
  width: 100%;
  float: right;
  color: #fff;
  font-size: changeRem(0.68)+px;
  background: #EA345C;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff;
  }
}

.play_foot {
  width: changeRem(13.8)+px;
  height: changeRem(2)+px;
  position: fixed;
  bottom: changeRem(2.56)+px;
  left: 50%;
  margin-left: changeRem(-6.9)+px;
  text-align: left;
  background: rgba(51, 51, 51, 0.7);
  border-radius: changeRem(0.16)+px;
  padding: changeRem(0.3)+px changeRem(0.6)+px;
  display: none;
  .play_f {
    width: changeRem(8.4)+px;
    float: left;
    h2 {
      color: #fff;
      font-size: changeRem(0.56)+px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: changeRem(0.2)+px;
      font-weight: normal;
      margin-top: 0;
    }
    h3 {
      color: #F0F0F0;
      font-weight: normal;
      font-size: 20px;
      // margin-top: changeRem(0.2)+px;
    }
  }
  .pause_h2 {
    width: changeRem(9.64)+px;
  }
  .play-btn {
    display: block;
    float: right;
    width: changeRem(1.38)+px;
    height: changeRem(1.38)+px;
    background: url(../../../assets/play_bottom.png) top left no-repeat;
    background-size: cover;
  }
  .pause_audio {
    background-position-x: right;
    background-size: cover;
  }
  img {
    width: changeRem(0.96)+px;
    display: inline-block;
    margin-right: changeRem(0.6)+px;
    float: left;
    margin-top: changeRem(0.2)+px;
    transition: all .5s;
  }
  .js_f {
    width: changeRem(8.4)+px;
    float: left;
    h2 {
      color: #fff;
      font-size: changeRem(0.56)+px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: changeRem(0.2)+px;
    }
    h3 {
      color: #F0F0F0;
      font-size: changeRem(0.4)+px;
      margin-top: changeRem(0.2)+px;
    }
  }
}

.show {
  display: block;
}

.hide {
  display: none;
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}

.banq {
  font-size: 26px;
  color: #666;
  width: 100%;
  padding: 20px;
  text-align: justify;
  margin: 20px 0;
}

.share_order {
  width: 100%;
  .share-content {
    padding: 30px 30px 0 30px;
  }
  img {
    float: right;
    width: 28px;
    margin: 0 30px 30px 30px;
  }
  h2 {
    color: #333;
    font-size: 34px;
    text-align: left;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .unlock-btn {
    position: relative;
    margin-top: 100px;
    padding-left: 214px;
    height: 98px;
    line-height: 98px;
    .unlock-btn-left {
      display: block;
      width: 214px;
      color: #666666;
      font-size: 24px;
      position: absolute;
      border-top: 1px solid #ccc;
      left: 0;
      bottom: 0;
      text-align: center;
      height: 98px;
      line-height: 1;
      div {
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        padding: 20px 0;
        span.money {
          display: inherit;
          font-size: 34px;
          color: #EB5032;
          line-height: 1;
        }
      }
    }
    .unlock-btn-right {
      background-color: #EB5032;
      color: #fff;
      text-align: center;
      display: block;
      font-size: 34px;
    }
    .unlock-btn-right.on {
      background-color: #cccccc;
    }
  }
}

.order_group {
  color: #EB5032;
  font-size: 26px;
  line-height: 70px;
  text-align: center;
  position: relative;
  float: left;
  width: 310px;
  border: 1px solid #EB5032;
  margin: 30px 0 0 0;
}

.order_group:nth-child(odd) {
  margin-left: 30px;
}

.order_group.radio_group_over {
  color: #999999;
  border-color: #ccc
}

.discounts {
  padding: 30px;
  margin-top: 80px;
  h2 {
    margin-bottom: 40px;
  }
  .discounts-radio {
    p {
      color: #999;
      font-size: 20px;
    }
    .van-cell {
      padding: 0;
      .van-cell__title {
        font-size: 26px;
        color: #333;
        display: flex;
        span {
          margin-left: auto;
          color: #EB5032;
          font-size: 26px;
          margin-right: 80px;
        }
      }
    }
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 44px 85px 34px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      // margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 24px;
    }
  }
}
</style>
<style lang="scss">
.container img {
  max-width: 100%;
}

.order_group {
  .van-radio .van-radio__icon {
    bottom: 0;
    top: auto;
  }
  .van-icon.van-icon-success {
    position: absolute;
    bottom: 0;
    right: 0;
    height: auto;
  }
  .van-radio .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
    width: 43px;
    height: 36px;
    background-image: url(../../../assets/radio_dw.png);
    background-size: cover;
    border-radius: 0;
    transition: .03s;
  }
  .van-radio__label {
    margin-left: 0;
    color: #EB5032;
    font-size: 26px;
  }
  .van-radio__icon.van-radio__icon--round .van-icon.van-icon-success {
    color: #fff;
    border-color: transparent;
    background-color: transparent;
    border: 0px;
  }
  .van-radio__icon.van-radio__icon--round .van-icon.van-icon-success::after,
  .van-icon.van-icon-success::before {
    content: ''
  }
}

.order_group.radio_group_over .van-radio__label {
  color: #999
}

.discounts-radio .van-hairline--top-bottom::after,
.discounts-radio .van-cell::after {
  border: 0;
}

.play_tab {
  width: 100%;
  text-align: center;
  margin-top: 50px;
  span {
    display: inline-block;
    width: 96px;
    border: 2px solid #ccc;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    color: #666;
    font-size: 20px;
    margin: 0 25px;
  }
}

.van-popup--bottom {
  background-color: none;
}

.list_audio {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 48px 48px 0px 0px;
  h2 {
    line-height: 86px;
    text-align: center;
    position: relative;
    font-size: 32px;
    color: #333;
    border-bottom: 2px solid rgba(240, 240, 240, 1);
    span {
      position: absolute;
      right: 30px;
      top: 0;
      font-size: 26px;
      color: #333;
    }
  }
  ul li {
    margin: 0 30px;
    border-bottom: 2px solid rgba(240, 240, 240, 1);
    line-height: 70px;
    a {
      display: block;
      width: 100%;
      height: 100%;
      font-size: 28px;
      color: #333;
    }
  }
}
</style>
